// extracted by mini-css-extract-plugin
export default {"accounts":"cQavuh","linked":"_QUl0C"};